import React from 'react';
import s from './ScrollToTopButton.scss';
import Icon from '../../../assets/icons/scroll-to-top-icon.svg?url';
import { Box, Text } from '@wix/design-system';
import classNames from 'classnames';
export const ScrollToTopButton = ({ text, onClick, isVisible, }) => {
    return (React.createElement("div", { onClick: onClick, className: classNames(s.wrapper, isVisible ? s.visible : s.hidden) },
        React.createElement(Box, { direction: "vertical", align: "center", gap: "6px", cursor: "pointer" },
            React.createElement("div", { className: s.icon },
                React.createElement("img", { src: Icon, alt: "Scroll to top" })),
            React.createElement(Text, { weight: "normal", size: "tiny", className: s.text }, text))));
};
//# sourceMappingURL=ScrollToTopButton.js.map